import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  JobEntityType,
  JobEntityTypeColors,
  JobEntityTypeIcons,
  JobEntityTypeLabels,
} from "../../models/Jobs/JobEntityType";

interface JobEntityTypeChipProps {
  type: JobEntityType;
}

const JobEntityTypeChip: React.FC<JobEntityTypeChipProps> = ({ type }) => {
  const Icon = JobEntityTypeIcons[type];

  return (
    <Badge variant="secondary" className="gap-1.5">
      {Icon && <Icon className="size-3" />}
      {JobEntityTypeLabels[type]}
    </Badge>
  );
};

export default JobEntityTypeChip;
